import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@application/config';
import { IGymSettings } from '../entities/gym-settings.interface';

@Injectable({ providedIn: 'root' })
export class GymSettingsService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl;

  public getTotalpassGymSettings(): Observable<IGymSettings> {
    return this.http.get<IGymSettings>(
      `${this.apiUrl.totalpass}/Gym/GetGymSettings`,
      { withCredentials: true },
    );
  }

  public getGympassGymSettings(): Observable<IGymSettings> {
    return this.http.get<IGymSettings>(
      `${this.apiUrl.gympass}/Gym/GetGymSettings`,
      { withCredentials: true },
    );
  }

  public updateTotalpassGymSettings(payload: IGymSettings): Observable<any> {
    return this.http.put(
      `${this.apiUrl.totalpass}/Gym/UpdateGymSettings`, payload, {
        withCredentials: true
      },
    );
  }

  public updateGympassGymSettings(payload: IGymSettings): Observable<any> {
    return this.http.put(
      `${this.apiUrl.gympass}/Gym/UpdateGymSettings`, payload, {
        withCredentials: true
      },
    );
  }
}
